import React                from 'react';
import PropTypes            from 'prop-types';
import NavBarDropdown       from './NavBarDropdown';
import ReloadHelper         from '../../utils/ReloadHelper';
import NavBarNewIcon        from './NavBarNewIcon';
import { trackNavbarClick } from '../../utils/GAHelper';
import './../../../../src/VX/Asset/Less/VX/07-components/video/NavBarNewIcon.less';

let hasSubNav  = false;
let isTouch    = false;

class NavBarItem extends React.PureComponent {

	setRef(ref) {
		if (ref) {
			ref.addEventListener('touchstart', () => {
				isTouch = true;
				if (this.props.subNavigation.length > 0) {
					hasSubNav = true;
				} else {
					hasSubNav = false;
				}
			});
			ref.addEventListener('click', (e) => {
				this.props.gaTracking && trackNavbarClick(this.props.gaTracking, this.props.link);
				e.preventDefault();
				if (!isTouch || !hasSubNav) {
					ReloadHelper.reloadWithPjax(this.props.link);
				}
				isTouch = false;
			});
		}
	}

	render() {
		let buttonClass = 'navbar__button';

		if (this.props.isHighlighted) {
			buttonClass = buttonClass + ' is-highlighted';
		}

		const sub = this.props.subNavigation.length > 0
			? <NavBarDropdown elements={this.props.subNavigation} parentName={this.props.gaTracking}/>
			: null;

		let caption = '';

		if (this.props.hasSale) {
			caption = (
				<span>
					{this.props.caption}
					<img className="navbar__icon-sale" src="/assets/img/special/videosale/navbar_badge_sale.png" />
				</span>
			);
		} else if (this.props.isNew) {
			caption = (
				<span className="navbar-new-icon-span">
					{this.props.caption}
					<NavBarNewIcon />
				</span>
			);
		} else {
			caption = this.props.caption;
		}

		return (
			<li className="navbar__navigation-item">
				<a href={this.props.link} className={buttonClass + (this.props.isNew ? " navbar__button--new" : "")} ref={(ref) => this.setRef(ref)} >
					{caption}
				</a>
				{sub}
			</li>
		);
	}
}

NavBarItem.propTypes = {
	caption:       PropTypes.string,
	isHighlighted: PropTypes.bool,
	isNew:         PropTypes.bool,
	hasSale:       PropTypes.bool,
	link:          PropTypes.string,
	subNavigation: PropTypes.array,
	gaTracking:    PropTypes.string,
};

NavBarItem.defaultProps = {
	subNavigation: [],
	isNew:         false,
	hasSale:       false,
	gaTracking:    '',
};

export default NavBarItem;
